"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupRefreshTokenResponse = exports.setAuthorization = exports.refreshTokenUpdate = exports.getUserFromSession = exports.WithAxios = exports.APICore = void 0;
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var _axios = _interopRequireDefault(require("axios"));
var _app = _interopRequireDefault(require("../../configs/app.config"));
var _dashboard = require("../../constants/endpoints/dashboard");
var _dateFns = require("date-fns");
var _NotificationContext = require("../../helpers/toasterNotification/NotificationContext");
var _react = require("react");
var _intercepterMessageHandler = require("../../helpers/intercepterMessageHandler/intercepterMessageHandler");
var _actions = require("../../redux/dashboard/actions");
var _actions2 = require("../../redux/tenant/actions");
var _reactRedux = require("react-redux");
var _genericFunction = require("../../helpers/genericFunction");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
_axios.default.defaults.headers.post["Content-Type"] = "application/json";
_axios.default.defaults.headers.common["react-app"] = "true";
_axios.default.defaults.baseURL = _app.default.baseUrl;
// axios.defaults.withCredentials = true;
// axios.defaults.headers.common["Access-Control-Allow-Origin"] = [
//   "localhost",
//   "barnard.react.dev.ovrture.com",
//   "barnard.api.dev.ovrture.io",
// ];
// axios.defaults.headers.common["Access-Control-Allow-Credentials"] = true;
// axios.defaults.headers.common["Access-Control-Allow-Headers"] = "*";
// axios.defaults.headers.common["Access-Control-Expose-Headers"] = "*";
var initialLoad = true;

/**
 * Intercepting to capture errors
 */
var WithAxios = function WithAxios(_ref) {
  var children = _ref.children;
  var _useNotification = (0, _NotificationContext.useNotification)(),
    Toast = _useNotification.Toast,
    ProgressToaster = _useNotification.ProgressToaster,
    Loader = _useNotification.Loader,
    setAutoClose = _useNotification.setAutoClose,
    deleteToast = _useNotification.deleteToast;
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    createAxiosInstance();
  }, []);
  var logoutSystem = function logoutSystem(response) {
    if (process.env.REACT_APP_CLIENT === "dashboard") {
      dispatch((0, _actions.authLogout)());
    } else if (process.env.REACT_APP_CLIENT === "tenant") {
      var _response$config, _response$config$url;
      dispatch((0, _actions2.tenantAuthLogout)());
      if (!(response !== null && response !== void 0 && (_response$config = response.config) !== null && _response$config !== void 0 && (_response$config$url = _response$config.url) !== null && _response$config$url !== void 0 && _response$config$url.includes("api/records/public/login"))) {
        setTimeout(function () {
          window.location.href = localStorage.getItem("loginUrl") || window.location.origin;
        }, 400);
      }
    }
  };
  var parseJwt = function parseJwt(token) {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };
  var checkLoaderNeeded = function checkLoaderNeeded(url) {
    if (url !== null && url !== void 0 && url.includes("refreshToken")) return false;
    if (url !== null && url !== void 0 && url.includes("api/user/activities")) return false;
    if (url !== null && url !== void 0 && url.includes("/api/records/unique/reference-no")) return false;
    if (url !== null && url !== void 0 && url.includes("/api/report/data/fund/unique/reference-no")) return false;
    if (url !== null && url !== void 0 && url.includes("/api/analytics/session/report")) return false;
    if (url !== null && url !== void 0 && url.includes("/api/analytics/session/site")) return false;
    if (url !== null && url !== void 0 && url.includes("/api/report/data/fund/list")) return false;
    if (url !== null && url !== void 0 && url.includes("/api/records/funds")) return false;
    if (url !== null && url !== void 0 && url.includes("/api/records/unique/url-extension")) return false;
    if (url !== null && url !== void 0 && url.includes("/api/content-panel/folder-view/initials/list")) return false;
    if (url !== null && url !== void 0 && url.includes("/api/asset/folder/list/initials")) return false;
    if (url !== null && url !== void 0 && url.includes("/api/asset/upload/bulk")) return false;
    if (sessionStorage.getItem(process.env.REACT_APP_DASHBOARD_SESSION_GENERIC_MSG_KEY) === "SKIP_LOADER") return false;
    if (sessionStorage.getItem("SKIP_LOADER_ALL") === "SKIP_LOADER_ALL") return false;
    if (sessionStorage.getItem("SKIP_LOADER_FOR_REPORT") === "SKIP_LOADER_FOR_REPORT") return false;
    //deleteToast();
    return true;
  };
  var createAxiosInstance = function createAxiosInstance() {
    var user = getUserFromSession();
    _axios.default.interceptors.request.use(function (request) {
      Loader.display(checkLoaderNeeded(request.url));
      return request;
    }, function (error) {
      return Promise.reject(error);
    });
    _axios.default.interceptors.response.use( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
        var _response$data, _response$data2, _response$data3;
        var diffTime, _response$data4, tenantUser, _response$data5, decodedJwt;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (checkLoaderNeeded()) Loader.display(false);
              if (!(user && ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) === 401 || (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.code) === 400 && (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.message) === "Authentication token is missing."))) {
                _context.next = 7;
                break;
              }
              if (!(response.config.url.includes("refreshToken") || response.config.url.includes("records/public/login"))) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", response);
            case 4:
              setAutoClose(false);
              if (process.env.REACT_APP_CLIENT === "dashboard") {
                setTimeout(function () {
                  Toast.danger({
                    title: "Expired",
                    description: "Your token has been expired, please login to continue.",
                    button: "Login",
                    handleClick: logoutSystem
                  });
                }, 1000);
              } else if (process.env.REACT_APP_CLIENT === "tenant") {
                dispatch((0, _actions2.tenantAuthLogout)());
                setTimeout(function () {
                  window.location.href = localStorage.getItem("loginUrl") || window.location.origin;
                }, 400);
              }
              return _context.abrupt("return", response);
            case 7:
              (0, _intercepterMessageHandler.intercepterMessageHandler)(Toast, ProgressToaster, response, _intercepterMessageHandler.intercepterMessageType.success);

              // This refreshToken code should be shifted under intercepterMessageHandler
              diffTime = (0, _dateFns.differenceInMinutes)(new Date(), new Date(user === null || user === void 0 ? void 0 : user.expiryDate));
              if (!(diffTime >= _app.default.refreshTime && diffTime < _app.default.tokenExpiryTIme && initialLoad)) {
                _context.next = 13;
                break;
              }
              initialLoad = false;
              _context.next = 13;
              return refreshTokenUpdate();
            case 13:
              if (process.env.REACT_APP_CLIENT == "tenant") {
                tenantUser = JSON.parse(localStorage.getItem("tenant_user"));
                if (tenantUser || (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.code) === 400) {
                  decodedJwt = tenantUser ? parseJwt(tenantUser === null || tenantUser === void 0 ? void 0 : tenantUser.token) : null;
                  if (!decodedJwt && (response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.message) === "Authentication token is missing.") {
                    setTimeout(function () {
                      dispatch((0, _actions2.tenantAuthLogout)());
                      window.location.href = window.location.origin;
                    }, 3000);
                  }
                }
              }
              return _context.abrupt("return", response);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(error) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (checkLoaderNeeded()) Loader.display(false);
              if (!user) {
                _context2.next = 4;
                break;
              }
              _context2.next = 4;
              return (0, _intercepterMessageHandler.intercepterMessageHandler)(Toast, ProgressToaster, error === null || error === void 0 ? void 0 : error.response, _intercepterMessageHandler.intercepterMessageType.danger, logoutSystem, user);
            case 4:
              return _context2.abrupt("return", error === null || error === void 0 ? void 0 : error.response);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
  };
  return children;
};
exports.WithAxios = WithAxios;
var axiosInterceptorResponse = function axiosInterceptorResponse(response) {};
var axiosInterceptorError = function axiosInterceptorError(response) {};

/**
 * Refresh Token Update
 * @param token
 * @description Fetch and update token on session storage.
 */
var refreshTokenUpdate = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(payload) {
    var user, diffTime, api;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          user = getUserFromSession();
          diffTime = (0, _dateFns.differenceInMinutes)(new Date(), new Date(user === null || user === void 0 ? void 0 : user.expiryDate));
          if (!user) {
            _context3.next = 17;
            break;
          }
          api = new APICore();
          if (!(payload !== null && payload !== void 0 && payload.isSystemAdmin)) {
            _context3.next = 10;
            break;
          }
          _context3.next = 8;
          return refreshTokenApiCall(api, user);
        case 8:
          _context3.next = 17;
          break;
        case 10:
          if (!(diffTime >= _app.default.tokenExpiryTIme)) {
            _context3.next = 14;
            break;
          }
          //user will be expire if time is >=30 minute
          initialLoad = true;
          _context3.next = 17;
          break;
        case 14:
          if (!(diffTime >= _app.default.refreshTime && diffTime < _app.default.tokenExpiryTIme)) {
            _context3.next = 17;
            break;
          }
          _context3.next = 17;
          return refreshTokenApiCall(api, user);
        case 17:
          _context3.next = 22;
          break;
        case 19:
          _context3.prev = 19;
          _context3.t0 = _context3["catch"](0);
          console.log("ex", _context3.t0);
        case 22:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 19]]);
  }));
  return function refreshTokenUpdate(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
exports.refreshTokenUpdate = refreshTokenUpdate;
var refreshTokenApiCall = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(api, user) {
    var response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return api.get("".concat(_app.default.baseUrl + _dashboard.GatewayService.refreshToken + user.refreshToken));
        case 2:
          response = _context4.sent;
          setupRefreshTokenResponse(response, api);
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function refreshTokenApiCall(_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}();
var setupRefreshTokenResponse = function setupRefreshTokenResponse(response, api_) {
  var _response$data6, _response$data7;
  if ((response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.code) === 200 && response !== null && response !== void 0 && (_response$data7 = response.data) !== null && _response$data7 !== void 0 && _response$data7.data) {
    var oldUser = api_.getLoggedInUser();
    var _user = (0, _genericFunction.setUserAuthentication)(response, oldUser);
    api_.setLoggedInUser(_user);
    setAuthorization(_user["token"]);
    initialLoad = true;
  }
};
exports.setupRefreshTokenResponse = setupRefreshTokenResponse;
var setNewToken = function setNewToken() {
  try {
    if (process.env.REACT_APP_CLIENT === "dashboard") {
      var _JSON$parse;
      var token = localStorage.getItem(process.env.REACT_APP_DASHBOARD_SESSION_AUTH_KEY);
      token = JSON === null || JSON === void 0 ? void 0 : (_JSON$parse = JSON.parse(token)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.token;
      token && setAuthorization(token);
    }
  } catch (error) {}
};

/**
 * Set Authorization
 * @param token
 * @description Sets the default authorization.
 */
var setAuthorization = function setAuthorization(token) {
  if (token) {
    _axios.default.defaults.headers.common["Authorization"] = token;
  } else delete _axios.default.defaults.headers.common["Authorization"];
};

/**
 * Get User From Session
 * @param token
 * @description Get user details from session.
 */
exports.setAuthorization = setAuthorization;
var getUserFromSession = function getUserFromSession() {
  var user = localStorage.getItem(_app.default.dashboard.localStorage.dashboardAuthSessionKey);
  return user ? _typeof(user) == "object" ? user : JSON.parse(user) : null;
};
exports.getUserFromSession = getUserFromSession;
var APICore = /*#__PURE__*/_createClass(function APICore() {
  var _this = this;
  _classCallCheck(this, APICore);
  /**
   * Fetches data from given url
   */
  _defineProperty(this, "get", function (url, params, headersConfig) {
    setNewToken();
    var response;
    if (params) {
      var queryString = "";
      if (params) {
        Object.keys(params).forEach(function (key) {
          if (key === "sortObj") {
            params[key].map(function (item) {
              Object.keys(item).forEach(function (k) {
                queryString += k + "=" + encodeURIComponent(item[k]) + "&";
              });
            });
          } else {
            queryString += key + "=" + encodeURIComponent(params[key]) + "&";
          }
        });
      }
      queryString = queryString.slice(0, -1);
      response = _axios.default.get("".concat(url, "?").concat(queryString), headersConfig);
    } else {
      response = _axios.default.get("".concat(url), headersConfig);
    }
    return response;
  });
  /**
   * Fetches data from file
   */
  _defineProperty(this, "getFile", function (url, params) {
    var response;
    if (params) {
      var queryString = params ? Object.keys(params).map(function (key) {
        return key + "=" + params[key];
      }).join("&") : "";
      response = _axios.default.get("".concat(url, "?").concat(queryString), {
        responseType: "arraybuffer"
      });
    } else {
      response = _axios.default.get("".concat(url), {
        responseType: "arraybuffer"
      });
    }
    return response;
  });
  /**
   * Fetches data from multiple file
   */
  _defineProperty(this, "getMultiple", function (urls, params) {
    var reqs = [];
    var queryString = "";
    if (params) {
      queryString = params ? Object.keys(params).map(function (key) {
        return key + "=" + params[key];
      }).join("&") : "";
    }
    var _iterator = _createForOfIteratorHelper(urls),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var url = _step.value;
        reqs.push(_axios.default.get("".concat(url, "?").concat(queryString)));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return _axios.default.all(reqs);
  });
  /**
   * post given data to url
   */
  _defineProperty(this, "create", function (url, data, headersConfig) {
    // return axios.post(url, data);
    var response;
    if (headersConfig) {
      response = _axios.default.post(url, data, headersConfig);
    } else {
      response = _axios.default.post(url, data);
    }
    return response;
  });
  _defineProperty(this, "createWithParam", function (url, params) {
    var response;
    if (params) {
      var queryString = params ? Object.keys(params).map(function (key) {
        return key + "=" + params[key];
      }).join("&") : "";
      response = _axios.default.post("".concat(url, "?").concat(queryString));
    } else {
      response = _axios.default.post("".concat(url), params);
    }
    return response;
  });
  _defineProperty(this, "createWithParamBody", function (url, params, data) {
    var response;
    if (params) {
      var queryString = params ? Object.keys(params).map(function (key) {
        return key + "=" + params[key];
      }).join("&") : "";
      response = _axios.default.post("".concat(url, "?").concat(queryString), data);
    } else {
      response = _axios.default.post("".concat(url), data);
    }
    return response;
  });
  _defineProperty(this, "getFileCreateWithParamBody", function (url, params, data) {
    var response;
    if (params) {
      var queryString = params ? Object.keys(params).map(function (key) {
        return key + "=" + params[key];
      }).join("&") : "";
      response = (0, _axios.default)({
        method: "post",
        url: "".concat(url, "?").concat(queryString),
        data: data,
        responseType: "arraybuffer"
      });
    } else {
      response = (0, _axios.default)({
        method: "post",
        url: "".concat(url),
        data: data,
        responseType: "arraybuffer"
      });
    }
    return response;
  });
  /**
   * Updates patch data
   */
  _defineProperty(this, "updatePatch", function (url, data) {
    return _axios.default.patch(url, data);
  });
  /**
   * Updates data
   */
  _defineProperty(this, "update", function (url, data, headersConfig) {
    setNewToken();
    return _axios.default.put(url, data, headersConfig);
  });
  _defineProperty(this, "updateWithParam", function (url, params) {
    setNewToken();
    var response;
    if (params) {
      var queryString = params ? Object.keys(params).map(function (key) {
        return key + "=" + params[key];
      }).join("&") : "";
      response = _axios.default.put("".concat(url, "?").concat(queryString));
    } else {
      response = _axios.default.put("".concat(url), params);
    }
    return response;
  });
  _defineProperty(this, "updateWithParamBody", function (url, params, data) {
    setNewToken();
    var response;
    if (params) {
      var queryString = params ? Object.keys(params).map(function (key) {
        return key + "=" + params[key];
      }).join("&") : "";
      response = _axios.default.put("".concat(url, "?").concat(queryString), data);
    } else {
      response = _axios.default.put("".concat(url), data);
    }
    return response;
  });
  /**
   * Deletes data
   */
  _defineProperty(this, "delete", function (url, params) {
    var response;
    if (params) {
      var queryString = params ? Object.keys(params).map(function (key) {
        return key + "=" + params[key];
      }).join("&") : "";
      response = _axios.default.delete("".concat(url, "?").concat(queryString), params);
    } else {
      response = _axios.default.delete("".concat(url));
    }
    return response;
  });
  /**
   * post given data to url with file
   */
  _defineProperty(this, "createWithFile", function (url, data) {
    var formData = new FormData();
    for (var k in data) {
      formData.append(k, data[k]);
    }
    var config = {
      headers: _objectSpread(_objectSpread({}, _axios.default.defaults.headers), {}, {
        "content-type": "multipart/form-data"
      })
    };
    return _axios.default.post(url, formData, config);
  });
  /**
   * post given data to url with file
   */
  _defineProperty(this, "createWithFileAndParam", function (url, params, data) {
    var response;
    var formData = new FormData();
    for (var k in data) {
      formData.append(k, data[k]);
    }
    var config = {
      headers: _objectSpread(_objectSpread({}, _axios.default.defaults.headers), {}, {
        "content-type": "multipart/form-data"
      })
    };
    if (params) {
      var queryString = params ? Object.keys(params).map(function (key) {
        return key + "=" + params[key];
      }).join("&") : "";
      response = _axios.default.post("".concat(url, "?").concat(queryString), formData, config);
    } else {
      response = _axios.default.post(url, formData, config);
    }
    return response;
  });
  _defineProperty(this, "createWithMultiFileAndParam", function (url, params, data, skipModalSocket) {
    var response;
    var formData = new FormData();
    for (var k in data) {
      for (var j in data[k]) {
        formData.append(k, data[k][j]);
      }
    }
    if (params) {
      Object.keys(params).forEach(function (key) {
        formData.append(key, params[key]);
      });
    }
    var config = {
      headers: _objectSpread(_objectSpread({}, _axios.default.defaults.headers), {}, {
        "content-type": "multipart/form-data",
        skipModalSocket: skipModalSocket
      })
    };
    response = _axios.default.post(url, formData, config);
    return response;
  });
  /**
   * post given data to url with file
   */
  _defineProperty(this, "updateWithFile", function (url, data) {
    var formData = new FormData();
    for (var k in data) {
      formData.append(k, data[k]);
    }
    var config = {
      headers: _objectSpread(_objectSpread({}, _axios.default.defaults.headers), {}, {
        "content-type": "multipart/form-data"
      })
    };
    return _axios.default.patch(url, formData, config);
  });
  /**
   * Check is user authenticated
   */
  _defineProperty(this, "isUserAuthenticated", function () {
    var user = _this.getLoggedInUser();
    if (!user || user && !user.token) {
      return false;
    }
    var decoded = (0, _jwtDecode.default)(user.token);
    var currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      console.warn("access token expired");
      return false;
    } else {
      return true;
    }
  });
  /**
   * set login user
   */
  _defineProperty(this, "setLoggedInUser", function (session) {
    if (session) {
      localStorage.setItem(_app.default.dashboard.localStorage.dashboardAuthSessionKey, JSON.stringify(session));
    } else {
      localStorage.removeItem("apiGatewayUrl");
      localStorage.removeItem("_grecaptcha");
      localStorage.removeItem(_app.default.dashboard.localStorage.dashboardAuthSessionKey);
      sessionStorage.clear();
    }
  });
  /**
   * Returns the logged in user
   */
  _defineProperty(this, "getLoggedInUser", function () {
    return getUserFromSession();
  });
  /**
   * Set user in session
   */
  _defineProperty(this, "setUserInSession", function (modifiedUser) {
    var userInfo = localStorage.getItem(_app.default.dashboard.localStorage.dashboardAuthSessionKey);
    if (userInfo) {
      var _JSON$parse2 = JSON.parse(userInfo),
        token = _JSON$parse2.token,
        _user2 = _JSON$parse2.user;
      _this.setLoggedInUser(_objectSpread(_objectSpread({
        token: token
      }, _user2), modifiedUser));
    }
  });
});
/**
 * Check if token available in session
 */
exports.APICore = APICore;
var user = getUserFromSession();
if (user) {
  var token = user.token;
  if (token) {
    setAuthorization(token);
  }
}